import { ImagesEntity } from '@galabid/gb-dashboard/shared/data-access-images'

export interface ProjectorsEntity {
  uuid: string
  name: string
  order?: number
  is_active: boolean
  created: string
  auction: string
  background_image: ImagesEntity | null | undefined
  background_image_file?: File | null
  background_image_cover: boolean
  background_color: string
  custom_css: string
  container: string | null
  font_family: string
  color: string
}

export interface AspectRatio {
  value: string
  label: string
  width: number
  height: number
}

export interface ZoomLevel {
  value: number
  label: string
}

export interface ReorderProjectorSlidesPayload {
  uuid: string
  order: number
}

export enum PresenterElementTypeEnum {
  TEMPLATES = 'templates',
  DIVIDER = 'divider',
  DIVIDER_MEDIA = 'divider-media',
  DIVIDER_RAFFLE = 'divider-raffle',
  TEXT = 'text',
  SMART_TEXT = 'smart-text',
  IMAGE = 'image',
  ITEM_TABLE = 'item-table',
  TOTAL_RAISED = 'total-raised',
  NOTIFICATION = 'notification',
  RAFFLE_DRAW = 'raffle-draw',
  RAFFLE_WINNERS = 'raffle-winners',
  THERMOMETER = 'thermometer',
  COUNTDOWN_TIMER = 'countdown-timer',
  HONOUR_ROLL = 'honour-roll',
  TEAM_SCORING = 'team-scoring',
  POWER_PLEDGE = 'power-pledge',
  QR_CODE = 'qr-code',
  VIDEO = 'video',
  ADVANCED_OPTIONS_DIVIDER = 'advanced-options-divider',
  CUSTOM_CSS = 'custom-css',
}

export const PROJECTORS_LOADER = {
  deleteProjector: {
    id: 'deleteProjector',
    message: 'LOADER.DELETING_PROJECTOR',
  },
  reorderSlides: {
    id: 'reorderSlides',
    message: 'LOADER.REORDERING_SLIDES',
  },
  deleteProjectorTemplate: {
    id: 'deleteProjectorTemplate',
    message: 'LOADER.DELETING_PROJECTOR_TEMPLATE',
  },
  updateProjector: {
    id: 'updateProjector',
  },
}
